import { stringify } from "qs";
import request from "../../request";
import { url } from "../../service-utils";
import { GetQueryString } from "../../utils";

// 获取局端汇总统计列表
export async function getBureauSummaryList(params) {
  return request(
    `${url.activitySign}/activity/item/edu-statistics?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 获取校端汇总统计列表
export async function getSchoolSummaryList(params) {
  return request(
    `${url.activitySign}/activity/item/org-statistics?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}
